function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", {
  fill: "#000000"
}, /*#__PURE__*/React.createElement("style", null, ".edit-icon{fill:none;stroke:#808080;stroke-miterlimit:10;stroke-width:0.7px;}"));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Add_Infos",
  "data-name": "Add Infos"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "edit-icon",
  points: "10.97 1.78 1 11.75 0.45 14.35 3.03 13.78 13.07 3.73 10.97 1.78",
  fill: "#000000"
}), /*#__PURE__*/React.createElement("line", {
  className: "edit-icon",
  x1: 3.03,
  y1: 13.78,
  x2: 1.09,
  y2: 11.66,
  fill: "#000000"
}), /*#__PURE__*/React.createElement("path", {
  className: "edit-icon",
  d: "M264.71,224.23l-1.18-1.18a.61.61,0,0,0-.85,0l-1.25,1.25,2.1,2,1.18-1.18A.59.59,0,0,0,264.71,224.23Z",
  transform: "translate(-250.46 -222.53)",
  fill: "#000000"
}));
function SvgEditGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "16px",
    height: "16px",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 14.77 14.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _ref2, title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Edit Pen-S") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditGrey);
export default __webpack_public_path__ + "static/media/Edit-grey.b2420bab.svg";
export { ForwardRef as ReactComponent };